var React = require('react');

function CloseIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20.207 3.793a1 1 0 0 0-1.414 0l-15 15a1 1 0 1 0 1.414 1.414l15-15a1 1 0 0 0 0-1.414z","fill":"#fff","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M3.793 3.793a1 1 0 0 1 1.414 0l15 15a1 1 0 0 1-1.414 1.414l-15-15a1 1 0 0 1 0-1.414z","fill":"#fff","key":1})]);
}

CloseIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CloseIcon;

CloseIcon.default = CloseIcon;
